import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stack, Skeleton, Typography } from '@esgian/esgianui';

const OverviewKeyValue = ({ title, value = null, loading = false }) => {
  const getValue = useMemo(() => {
    if (loading) {
      return <Skeleton width={'100%'} />;
    }
    if (typeof value === 'string' || value instanceof String) {
      return <Typography variant={'body2'}>{value}</Typography>;
    }
    return value;
  }, [loading, value]);

  return (
    <Stack direction={'row'} spacing={1}>
      <Typography sx={{ whiteSpace: 'nowrap' }} variant={'body2'} bold>
        {title}
      </Typography>
      {getValue}
    </Stack>
  );
};

OverviewKeyValue.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  loading: PropTypes.bool
};
export default OverviewKeyValue;
